import { useState, useEffect } from "react";
import { apiSend, getRoute } from "@services/axios";
import { message } from "antd";

export const useSignUpConf = () => {
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [loading, setLoading] = useState(true);
  // Load currencies
  useEffect(() => {
    const loadCurrencies = async () => {
      try {
        const response = await apiSend(getRoute("currencies"), "get", []);
        const formatted = response.data.result.map((currency) => ({
          id: currency.code,
          name: currency.name,
        }));
        setCurrencies(formatted);
      } catch (error) {
        console.error("Currency error:", error);
        message.error("Unable to load currencies.");
      }
    };

    loadCurrencies();
  }, []);

  // Load countries
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await apiSend(getRoute("countries")+'/all', "get", []);
        
        const formatted = response.data.result.map((country) => ({
          // console.log('Country data:', countryData);
          id: country.id,
          name: country.name,
        }));
        setCountries(formatted);
      } catch (error) {
        console.error("Country error:", error);
        message.error("Unable to load countries.");
      } finally {
        setLoading(false);
      }
    };

    loadCountries();
  }, []);

  // Load cities when country changes
  useEffect(() => {
    if (!selectedCountry) {
      setCities([]);
      return;
    }

    const loadCities = async () => {
      try {
        const response = await apiSend(
          [getRoute("cities"), selectedCountry,'/all'].join("/"),
          "get",
          []
        );
        const formatted = response.data.result.map((city) => ({
          id: city.id,
          name: city.name,
        }));
        setCities(formatted);
      } catch (error) {
        console.error("City error:", error);
        message.error("Unable to load cities.");
      }
    };

    loadCities();
  }, [selectedCountry]);

  return {
    currencies,
    countries,
    cities,
    selectedCountry,
    setSelectedCountry,
    loading,
  };
};
